/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { atom } from "jotai";
import { BaseService } from "@/frameworks/libraries/restservice";

class Common extends BaseService {
	constructor() {
		super();
	}

	private CommonAPIPath = (path?: string) => `/api/common${path ? `/${path}` : ""}`;

	private static Cache = {
		SupportLanguage: atom<WebServices.Commons.SupportLanguages.Response>({}),
		SupportTimezone: atom<WebServices.Commons.SupportedTimeZones.Response>({}),
		Default: {
			ProfileImages: {
				List: atom<WebServices.Default.ProfileImage.List.Response>({})
			}
		},
		DeleteReasonTypes: atom<WebServices.Commons.GetDeleteReasonTypes.Response>({})
	};

	public supportLanguages = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Commons.SupportLanguages.Request) =>
			this.get(this.CommonAPIPath("supportLanguages"), parameter),
		cache: Common.Cache.SupportLanguage
	});

	public supportTimezones = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Commons.SupportedTimeZones.Request) =>
			this.get(this.CommonAPIPath("supportTimezones"), parameter),
		cache: Common.Cache.SupportTimezone
	});

	public deleteReasonTypes = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Commons.GetDeleteReasonTypes.Request) =>
			this.get(this.CommonAPIPath("deleteReasonTypes"), parameter),
		cache: Common.Cache.DeleteReasonTypes
	});
}

class Defaults extends BaseService {
	constructor() {
		super();
	}

	private static Cache = {
		ProfileImages: {
			List: atom<WebServices.Default.ProfileImage.List.Response>({})
		}
	};

	public profileImage = {
		list: (name: string, events: API.Events) => ({
			name,
			events,
			callback: (parameter: WebServices.Default.ProfileImage.List.Request) =>
				this.get("/api/default_profile_images", parameter),
			cache: Defaults.Cache.ProfileImages.List
		})
	};
}

class CommonServiceStatic {
	constructor(
		public common = new Common(),
		public defaults = new Defaults()
	) {}
}

const CommonService = new CommonServiceStatic();
export default CommonService;
